import { useEffect, useState } from "react";
import { navTopics } from "@/mocks/jiukanliao";

const NAV_LINKS = [
  { href: "#home", label: "首屏热榜" },
  { href: "#hot", label: "九宫格图集" },
  { href: "#shots", label: "截图合集" },
  { href: "#alerts", label: "多图预警" },
  { href: "#topics", label: "题材目录" },
  { href: "#faq", label: "看图须知" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid ? "bg-[#fbf6ec]/95 backdrop-blur border-b border-[#eadbc0]" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] max-w-[1440px] items-center justify-between gap-4 px-4 md:px-8">
        <a href="#home" className="flex items-center gap-2 shrink-0">
          <span className="flex h-9 w-9 md:h-10 md:w-10 items-center justify-center rounded-xl bg-gradient-to-br from-[#ff7a45] to-[#d9431f] text-background">
            <i className="ri-image-2-line text-lg text-white" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-xl md:text-2xl font-black tracking-wide text-[#231f18]">
              9看料
            </span>
            <span className="mt-0.5 hidden text-[10px] tracking-[0.2em] text-[#a48a5d] sm:block">
              九宫格 · 九图 · 猛料
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-3.5 py-2 text-[13px] font-medium text-[#4c4436] transition hover:bg-[#f0e3ca] hover:text-[#b43a17]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#alerts"
            aria-label="搜索"
            className="hidden h-9 w-9 items-center justify-center rounded-full text-[#6b5f48] transition hover:bg-[#f0e3ca] sm:flex"
          >
            <i className="ri-search-line text-lg" />
          </a>
          <a
            href="#subscribe"
            className="hidden items-center gap-1.5 whitespace-nowrap rounded-full bg-[#d9431f] px-4 py-2.5 text-[13px] font-semibold text-white transition hover:bg-[#b83516] sm:inline-flex"
          >
            <i className="ri-notification-3-line" />
            开启追更
          </a>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-[#e3d2b0] text-[#4c4436] lg:hidden"
          >
            <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
          </button>
        </div>
      </div>

      <div className="flex gap-2 overflow-x-auto px-4 pb-1 no-scrollbar lg:hidden">
        {navTopics.map((t) => (
          <a
            key={t.id}
            href="#hot"
            className="whitespace-nowrap rounded-full border border-[#e6d6b6] px-3 py-1 text-xs text-[#6b5f48]"
          >
            {t.label}
          </a>
        ))}
      </div>

      {open && (
        <div className="border-t border-[#eadbc0] bg-[#fbf6ec] px-4 pb-4 lg:hidden">
          <div className="flex flex-col py-2">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-3 text-sm text-[#4c4436] transition hover:bg-[#f0e3ca]"
              >
                {l.label}
              </a>
            ))}
          </div>
          <a
            href="#subscribe"
            onClick={() => setOpen(false)}
            className="flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-[#d9431f] px-4 py-2.5 text-sm font-semibold text-white"
          >
            <i className="ri-notification-3-line" />
            开启追更
          </a>
        </div>
      )}
    </header>
  );
}